import { CategoryIcon } from "../../ui";
import type { ExpenseCategory } from "../types";

/**
 * Compact category chip — coloured square + name. Used inline in row
 * cells, tooltips, and the CategoryPicker trigger.
 */
export function CategoryBadge({ category }: { category: ExpenseCategory }) {
  return (
    <>
      <span
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md text-white"
        style={{ backgroundColor: category.color }}
        aria-hidden="true"
      >
        <CategoryIcon name={category.icon ?? "tag"} size="xs" />
      </span>
      <span className="truncate text-ink-900">{category.name}</span>
    </>
  );
}
